import React, { FC, memo } from 'react';
import styles from './Loader.module.scss';
import cn from 'classnames';

interface Props {
  isHidden?: boolean;
  className?: string;
}

const Loader: FC<Props> = ({ isHidden, className }) => {
  if (!isHidden) {
    return (
      <div className={cn(styles.wrapper, className)}>
        <div className={styles.loader}>
          <div />
          <div />
          <div />
          <div />
        </div>
      </div>
    );
  }
  return null;
};

export default memo(Loader);
